import "./index.scss";

export const BreadcrumbContainer = ({ children }) => {
  return <div className="breadcrumb-container">{children}</div>;
};
